import { redirect, createFileRoute } from '@tanstack/react-router'
import { getPlayerSession } from '@/features/player-session'

export const Route = createFileRoute('/register')({
  beforeLoad: async () => {
    const playerSession = await getPlayerSession()

    if (playerSession.isUserLoggedIn) {
      return redirect({ to: '/' })
    }

    await playerSession.login({
      doesCurrentHrefRequiresAuth: false,
      transformUrlBeforeRedirect: (url) => {
        const urlObj = new URL(url)

        urlObj.pathname = urlObj.pathname.replace(/\/auth$/, '/registrations')

        return urlObj.href
      },
    })
  },
})
